import type { InteractionType } from '~/model/InteractionType';
import { VpIcon, VpSticker } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { getTranslateKeyFromTag } from '~/components/utils';
import { defineIconValue } from '~/utils/interaction/tag';

export const InteractionTagSticker = ({
  interaction,
}: {
  interaction: InteractionType;
}) => {
  const t = useTranslations();
  const iconValue = defineIconValue(interaction.tag);

  return (
    <VpSticker variant="secondary" className="interaction-tag-sticker">
      <VpIcon name={iconValue} size={16} />
      {' '}
      <span>{t(getTranslateKeyFromTag(interaction.tag))}</span>
    </VpSticker>
  );
};
